export const Bio = {
  name: "Pawan kalyan",
  roles: [
    "Data Engineer",
    "Web Developer",
    "Android Developer",
  ],
  description:
    "I am a Data Engineer at KPI Partners, working with the client Netgear as a Python Engineer. I hold a degree in Information Technology from Chennai Institute of Technology, with experience in full-stack and Android app development.",
  github: "https://github.com/Pawankalyan2023",
  resume:
    "https://drive.google.com/file/d/1b-Y3-cxdfohcjM_W2tXWZFo_T-C-mL80/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/pawankalyan3/",
  // twitter: "https://mobile.twitter.com/pawan41847304",
  // insta: "https://instagram.com/bpawankalyanp?igshid=ZDdkNTZiNTM=",
  // facebook: "https://m.facebook.com/pavan.pawan.1213/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Typescript",
        image:
          "https://logospng.org/wp-content/uploads/typescript.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "AntDesign",
        image : 
            "https://avatars.githubusercontent.com/u/12101536?s=200&v=4"
      }
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://hackersandslackers-cdn.storage.googleapis.com/2020/05/express.png",
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
      // {
      //   name: "Python",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      // },
      {
        name: "MySQL Lite",
        image:
          "https://pngimg.com/uploads/mysql/mysql_PNG35.png",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://iconape.com/wp-content/files/rr/81003/png/mongodb.png",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      // {
      //   name: "Java",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      // },
      // {
      //   name: "Kotlin",
      //   image:
      //     "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      // },
      // {
      //   name: "XML",
      //   image:
      //     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      // },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
      {
        name: "React Native",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },

    ],
  },
  {
    title  : "Cloud",
    skills : [
      {
      name : "AWS",
      image : "https://www.pngplay.com/wp-content/uploads/3/Amazon-Web-Services-AWS-Logo-Transparent-PNG.png"
      },
      {
        name : "Azure",
        image : "https://tse1.mm.bing.net/th/id/OIP.RBEEEh9FaW1dsFVobvP28wHaHa?cb=thfc1&rs=1&pid=ImgDetMain&o=7&rm=3"
      }
    ]
  },
  {
    title : "Data Engineer",
    skills : [
      {
        name : "DataBricks",
        image : "https://w7.pngwing.com/pngs/769/465/png-transparent-databricks-full-logo-tech-companies.png"
      },
      {
        name : "DBT",
        image : "https://seeklogo.com/images/D/dbt-logo-E4B0ED72A2-seeklogo.com.png"
      },
      {
        name : "Informatica Intelligent Cloud Services(IICS)",
        image : "https://tse1.mm.bing.net/th/id/OIP.TJEiN26GBAEzFXD8-qnx3QHaEK?cb=thfc1&rs=1&pid=ImgDetMain&o=7&rm=3",
      },
      {
        name : "SnowFlake",
        image : "https://logos-world.net/wp-content/uploads/2022/11/Snowflake-Emblem.png"
      }
    ]
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://logodix.com/logo/812576.jpg  ",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name : "Jest",
        image : "https://tse3.mm.bing.net/th/id/OIP.HOVSFDKdrgzTxcpRiURzeAHaCe?cb=thfc1&rs=1&pid=ImgDetMain&o=7&rm=3"
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://w7.pngwing.com/pngs/877/217/png-transparent-postman-logo-tech-companies.png",
      },
      {
        name: "Adobe XD",
        image:
          "https://static.vecteezy.com/system/resources/previews/018/931/945/non_2x/adobe-xd-icon-free-png.png",
      },
      {
        name: "Figma",
        image:
          "https://www.pngall.com/wp-content/uploads/13/Figma-Logo-PNG-File.png",
      },
    ],
  },
];


export const coding = [
  {
    name: "leetcode",
    img: "https://cdn.iconscout.com/icon/free/png-256/free-leetcode-3521542-2944960.png?f=webp&w=256",
    link: "https://leetcode.com/lordoflegend2003/"
  },

  {
    name: "Skillrack",
    img: "https://yt3.ggpht.com/a-/AN66SAz5hy2hxiCCoJWb1xjAgJLlkJmGqkwP_hGv4g=s900-mo-c-c0xffffffff-rj-k-no",
    link: "https://www.skillrack.com/faces/resume.xhtml?id=383896&key=6759b86159bc2967fefd3daf77e6858f610e68f2"
  },

  {
    name: "Codechief",
    img: "https://sarvesh18.github.io/images/CodeChef.png",
    link: "https://www.codechef.com/users/pk_2003"
  },
  {
    name: "Code Ninjas",
    img: "https://cdn.dribbble.com/users/5043/screenshots/7227470/media/4144d9e23d09fc0b3d2414cdfe84f449.gif?resize=400x0",
    link: "https://www.codingninjas.com/studio/profile/9f89bb36-bc04-45f7-b60e-73019ddcaa07"
  },


  {
    name: "Geeks For Geeks",
    img: "https://media.geeksforgeeks.org/gfg-gg-logo.svg",
    link: "https://auth.geeksforgeeks.org/user/lordoflegend2003/practice"
  },

  

];


export const experiences = [
  {
    id : 3,
    img : "https://www.pngfind.com/pngs/m/437-4372938_logo-kpi-png-kpi-partners-logo-transparent-png.png",
    role : "Data Engineer I",
    company : "KPI Partners",
    date : "April 2025 - Present",
    desc : "Started as an intern and continued working with the company, contributing to client projects such as Thermo Fisher, where I worked on a tech stack involving Informatica with Databricks, and Netgear, where I served as a Python Developer using IICS.",
    skills : [
      "DataBricks",
      "Python",
      "Informatica",
      "Azure Cloud",
      "DBT"
    ]
  },
  {
    id : 1,
    img : "https://media.licdn.com/dms/image/v2/D4D0BAQFGPttQMYofww/company-logo_200_200/B4DZhapcc9GsAI-/0/1753867471888/peakline_technologies_private_limited_logo?e=1757548800&v=beta&t=clGwPrS6rDA9468ib23i3njNxabe_lt1nkVO1Wx0Fq0",
    role : "Softwrae Engineer Intern",
    company : "Peakline Technology Private Limited",
    date : "Jan 2025 - April 2025",
    desc : "Worked as an intern on a project called BTL King, which involved providing a CRM solution for the FMCG sector. During my tenure, I primarily led the frontend development of the application, creating new features, and also contributed to the backend, particularly in implementing routing functionality.",
    skills : [
      "TypeScript",
      "React.js",
      "Ant Design",
      "Express.js"
    ],
  },
  {
    id: 0,
    img: "https://aivirex.in/assets/img/favicon/apple-touch-icon.png",
    role: "Web Development Intern",
    company: "Aivirex Innovation.",
    date: "July 2023 - Present",
    desc: "Working on Miller International , Spearheaders official websites",
    skills: [
      "HTML",
      "CSS",
      "Javascript",
      "Bootstrap",
    ],
  }
];

export const education = [
  {
    id: 0,
    img: "https://images.shiksha.com/mediadata/images/1583389585phpP9W1tB.jpg",
    school: "Chennai Institute of Technology",
    date: "Oct 2021 - May 2025",
    grade: "8.95 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Information Technology at Chennai Institute Of Technology, Chennai. I have completed 4 semesters and have a CGPA of 8.75. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://targetstudy.com/files/img/2/73609/L_43462.gif",
    school: "Thangamani Matric Higher Secondary School , chennai.",
    date: "Apr 2019 - Apr 2021",
    grade: "85%",
    desc: "I completed my class 12  , 11 high school education at Thangamani matric higher secondary school , chennai , where I studied Science with Computer Science.",
    degree: "XII , XI",
  },
  {
    id: 2,
    img: "https://shrikrishnaswamyschools.edu.in/wp-content/themes/skg/img/logo.png ",
    school: "Shri Krishnaswamy Matric Higher Secondary School. Chennai",
    date: "Apr 2017 - Apr 2019",
    grade: "75%",
    desc: "I completed my class 10 education at shri krishnaswamy matric higher secondary school",
    degree: "X(SSLC)",
  },
];

export const projects = [
  {
    id : 0,
    title : "RideFlow Data Pipeline",
    date : "Jun 2025 - Jul 2025",
    description : "Developed a comprehensive travel analytics pipeline processing trip and rating data for a ride-hailing domain similar to Uber and Ola. Utilized Azure Data Factory to ingest and orchestrate data from multiple sources, Azure Databricks for scalable transformation and processing, and Azure Logic Apps to automate workflows and trigger email notifications. The solution enables near real-time analytics, providing actionable insights into trip patterns, customer ratings, and operational performance.",
    image : "",
    tags : [
      'Azure Data Factory',
      'Azure Logic App',
      'Azure ADLS Blob Storage',
      'Azure DataBricks'
    ],
    category: "dataengineer app",
    // github: "https://github.com/Pawankalyan2023/CODECALENDAR",
    // live : "https://code-calendar.vercel.app/"
  },
  {
    id : 1,
    title : "SkyTrack Data Pipeline",
    date : "Jul 2025 - Aug 2025",
    description : "Designed and implemented an end-to-end aviation data engineering pipeline integrating flight, passenger, airport, and booking datasets. Leveraged Databricks with Medallion architecture for scalable transformation and processing, while incorporating DBT for advanced transformations and data modeling. The project delivers a robust, analytics-ready dataset enabling actionable insights into air travel trends and operational performance.",
    image : "",
    tags : [
      "Databricks",
      "DBT",
      "Python",
      "Data Modelling",
      "SQL"
    ],
    category: "dataengineer app",
    // github: "https://github.com/Pawankalyan2023/CODECALENDAR",
    // live : "https://code-calendar.vercel.app/"
  },
 {
    id : 2,
    title : "FlightDesk",
    date : "Apr 2024 – Aug 2024",
    description : "Built a full-stack flight booking system leveraging React.js, Express.js, PostgreSQL, and Docker for scalable deployment, with Flowbite for a modern and responsive UI. Implemented key features including automated report generation, an intuitive admin dashboard for managing bookings and users, and integrated RapidAPI to display nearby hotel options. The system delivers a seamless end-to-end booking experience while providing powerful tools for administrators.",
    image : "",
    tags : [
      "React.js",
      "Express.js",
      "Node.js",
      "Flowbite",
      "PostgreSQL",
      "Docker"
    ],
    category: "web app",
    github: "https://github.com/Pawankalyan2023/Flbksys",
    webapp : "https://fbs-client.vercel.app/"
  },
  {
    id : 3,
    title : "Code Calendar",
    date : "Dec 2023 - Jan 2024",
    description : "Developed CodeCalendar, a web application built with React.js, Express.js, Node.js, and Flowbite, integrating the Clist.by API to aggregate contest data from popular competitive programming platforms such as Codeforces, LeetCode, and CodeChef. The system allows users to track upcoming competitions and sync them directly to Google Calendar, ensuring timely reminders. Additionally, it provides insights into participants’ past performances, helping the competitive programming community stay informed, improve their skills, and engage more effectively with coding events.",
    image : "",
    tags : [
      "React.js",
      "Express.js",
      "Node.js",
      "Flowbite",
      "Clist.by"
    ],
    category: "web app",
    github: "https://github.com/Pawankalyan2023/CODECALENDAR",
    live : "https://code-calendar.vercel.app/"
  },
  {
    id : 5,
    title : "DR-Free",
    date : "May 2024 - Jun 2024",
    description : "Created Dr Free, a mobile application built with React Native, Expo CLI, Express.js, Node.js, MongoDB, Firebase, and OpenAPI, aimed at helping individuals overcome drug addiction. The app uses real-time geolocation tracking to detect proximity to drug-supplying areas and sends instant push notifications to discourage relapse. It features a chatbot for empathetic conversations with users, offering guidance and support, while Firebase handles secure authentication. This project advanced to the semi-finals in an inter-college hackathon, showcasing its social impact and innovative approach to technology-driven rehabilitation.",
    image : "",
    tags : [
      "React Native",
      "Express.js",
      "Node.js",
      "MongoDB",
      "Firebase",
      "OpenAPI"
    ],
    category: "android app",
    github: "https://github.com/Pawankalyan2023/DRFREE/",
  },
  {
    id : 6,
    title : "E-Learning Application",
    date : "Jan 2024 - Feb 2024",
    description : "Developed an eLearning mobile application using React Native, Expo CLI, GraphQL, Hygraph, and Docker, serving as a centralized platform for accessing educational content. The app integrates free YouTube playlists alongside user-created courses, providing a diverse learning resource in one place. Leveraging GraphQL for fast, efficient JSON responses and Hygraph for content management, the system ensures smooth API request handling, optimized storage, and flexible content formatting for an enhanced learning experience.",
    image : "",
    tags : [
        "React Native",
        "Expo CLI",
        "GraphQL",
        "Hygraph",
        "Docker"
    ],
    category: "android app",
    github: "https://github.com/Pawankalyan2023/ACLMS",
  },
  {
    id: 9,
    title: "Online E-Commerce Tracking System",
    date: "April 2023 - March 2023",
    description:
      "Focuses on enhancing the customer experience by providing a convenient and accurate tracking system for e-commerce orders.",
    image:
      "https://helpful-kulfi-f35e99.netlify.app/assets/OETS.png",
    tags: [
      "HTML",
      "CSS",
      "Javascript",
      "Google API(Maps)",
    ],
    category: "web app",
    github: "https://github.com/Lordoflegend2003/Online-E-Commerce-tracking-System-OETS-",
  },
  // {
  //   id: 9,
  //   title: "Social Media Application",
  //   date: "Augest 2023 - Present",
  //   description:
  //     "Full fledged socially communicating application for effective communication between different users.",
  //   image:
  //     "https://helpful-kulfi-f35e99.netlify.app/assets/sm.png",
  //   tags: [
  //     "React",
  //     "Readux",
  //     "ExpressJs",
  //     "NodeJs",
  //     "MongoDB",
  //     "Material UI",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/Lordoflegend2003/socialmedia",
  // },
  {
    id: 0,
    title: "Student Results Management System",
    date: "May 2023 - June 2023",
    description:
      "The project is generally combined with a college official website that will provide u a section of content to get ur results on the go within the website",
    image:
      "https://helpful-kulfi-f35e99.netlify.app/assets/strms.png",
    tags: ["HTML", "CSS", "Javascript", "MySQL", "PHP" ,"Apache"],
    category: "web app",
    github: "https://github.com/Lordoflegend2003/LGM-SRMS",
  },
  {
    id: 1,
    title: "Quiz Application",
    date: "July 2023 - Augest 2023",
    description:
      "Simple quiz Application that will provide u with the no of questions and each answers gets counted and printed as a result after the end of the competition",
    image:
      "https://helpful-kulfi-f35e99.netlify.app/assets/quiz.png",
    tags: [
      "Flutter",
      "Dart",
      "Android Studio",
      "Visual Studio Code",
    ],
    category: "android app",
    github: "https://github.com/Lordoflegend2003/OIBSIP-/tree/master/quizapp/quizapp",
  },
  // {
  //   id: 2,
  //   title: "Chat App",
  //   date: " September 2023 - Present",
  //   description:
  //     "A Communication Based Application created with advanced technologies",
  //   image:
  //     "https://imgs.search.brave.com/txs4cGy4INWez057E4YUA8YqIho9hViFP0YDHYLKj0c/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9zdGF0/aWMwLnBvY2tldGxp/bnRpbWFnZXMuY29t/L3dvcmRwcmVzcy93/cC1jb250ZW50L3Vw/bG9hZHMvd20vMTM4/MTE1LWFwcHMtZmVh/dHVyZS0zMi1zZWNy/ZXQtd2hhdHNhcHAt/dHJpY2tzLXlvdS1t/aWdodC1ub3Qta25v/dy1hYm91dC1pbWFn/ZTQtNjV1OWhqbjB2/YS5qcGc",
  //   tags: ["React Native", "Expo CLI", "MongoDB", "Express.js", "Node.js", "Axios"],
  //   category: "android app",
  //   // github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
  //   // webapp: "https://brain-tumor.netlify.app/",
  // },
  // {
  //   id: 3,
  //   title: "Todo App",
  //   date: "June 2023 - July 2023",
  //   description:
  //     "A task management application for creating, organizing, and tracking to-do items.",
  //   image:
  //     "https://helpful-kulfi-f35e99.netlify.app/assets/todo.png",
  //   tags: ["Flutter", "Dart", "Android Studio"],
  //   category: "android app",
  //   github: "https://github.com/Lordoflegend2003/OIBSIP-/tree/master/todoapp",
  // },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];


export const achievementsData = [
  {
    id : 0,
    desc : "Led a team as Team Leader in the Inter-College Smart India Hackathon, securing a Finalist position at HackFusion.",
  },
  {
    id : 1,
    desc : "Worked as a Technical Lead in college symposium for three consecutive years (2022-2024).",
  },
  {
    id : 2,
    desc : "Techgig Code Gladiators Semi-Finalist in 2023, and Finalist in 2024.",
  },
  {
    id : 3,
    desc :  "Mastered over 922 challenges on Leetcode Leetcode, achieving a remarkable contest rating of 1850(Knight) among top 5.93%.",
  },
  {
    id : 4,
    desc : "Completed a substantial 1685 problems on Skillrack, earning 305 Bronze Medals."
  },  
  {
    id : 5,
    desc : "Initiated open-source contributions with CBoard and 3+ More repositories.",
  }
]


export const certification = [
  {
    id : 2,
    desc : "Databricks Certified Data Engineer Associate",
    link : "https://www.linkedin.com/feed/update/urn:li:activity:7355475408009482240/"
  },
  {
    id : 0,
    desc : "Cisco Virtual Internship 2023",
    link : "https://www.linkedin.com/posts/pawankalyan3_cisco-cybersecurity-activity-7109125649360965632-ocmA?utm_source=share&utm_medium=member_desktop"
  },
  {
    id : 1,
    desc : "Introduction to Docker",
    link : "https://www.coursera.org/account/accomplishments/verify/4SBQJTHZTT4P",
  },
  {
    id : 3,
    desc : "Cisco Certified Network Associate (CCNA)",
    link : "https://www.credly.com/badges/8953ba15-013e-4088-8d36-14acdb5e0b97/public_url"
  },
  {
    id : 4,
    desc : "The Complete 2024 Web Development.",
    link : "https://udemy-certificate.s3.amazonaws.com/pdf/UC-13cf1488-6286-45c5-9119-727c04dcb0d2.pdf"
  },
  {
    id : 5,
    desc : "Google Cloud Fundamentals: Core Infrastructure.",
    link : "https://www.coursera.org/account/accomplishments/verify/Y9TK9BDAA3NU"
  }
]